// extracted by mini-css-extract-plugin
export default {"chatPopup":"chatPopup__se+2+","closePopup":"closePopup__gj1By"};